import Topnavbar from "../../../Layouts/Topnavbar";
import { Container, Grid, Paper, Text, Title, Group, ThemeIcon, Button, Drawer, Select, Modal, Switch, Stack, SimpleGrid, TextInput, Textarea, PasswordInput, Center, Box, Progress, Badge, NumberInput, PinInput, Checkbox } from "@mantine/core";
import React, { useState, useEffect } from "react";
import {
    Table,
    Tag,
    Typography,
    Row,
    Col,
    DatePicker,
    Input,
    Space,
    Card, message, Descriptions, Divider, Empty, Spin,
} from "antd";
import { Userauthcontexthooks } from "../../../Hooks/Userauthcontexthooks";
import dayjs from "dayjs";
import { Admin_Bank_Add, Admin_Bank_Delete, Admin_Banks_get, Get_All_Users, Get_FundLogs, Get_Individual_user_wallet_details, Get_LoginLogs, Master_Dist_Signup, Update_Master_dist_details, Update_user_wallet_hold_balance, Update_user_wallet_status } from "../../../apicall";
import { IconCheck, IconX } from "@tabler/icons-react";
const { Search } = Input;










const Fundlogs = ({ Headername }) => {
    const columns = [
        {
            title: "S.No.",
            width: 60,
            align: "center",
            render: (_, __, index) => index + 1,
        },
        {
            title: "From User",
            width: 240,
            render: (_, record) => (
                <>
                    <Text fw={600}>
                        {record.fromDetails?.userName}
                    </Text>

                    <Text size="xs" c="dimmed">
                        {record.fromDetails?.userCode}
                    </Text>

                    <Tag
                        size="small"
                        color={
                            record.fromDetails?.userType === "Admin"
                                ? "red"
                                : record.fromDetails?.userType === "Master Distributor"
                                    ? "purple"
                                    : record.fromDetails?.userType === "Distributor"
                                        ? "blue"
                                        : "green"
                        }
                    >
                        {record.fromDetails?.userType}
                    </Tag>
                </>
            ),
        },
        {
            title: "To User",
            width: 240,
            render: (_, record) => (
                <>
                    <Text fw={600}>
                        {record.toDetails?.userName}
                    </Text>

                    <Text size="xs" c="dimmed">
                        {record.toDetails?.userCode}
                    </Text>

                    <Tag
                        size="small"
                        color={
                            record.toDetails?.userType === "Admin"
                                ? "red"
                                : record.toDetails?.userType === "Master Distributor"
                                    ? "purple"
                                    : record.toDetails?.userType === "Distributor"
                                        ? "blue"
                                        : "green"
                        }
                    >
                        {record.toDetails?.userType}
                    </Tag>
                </>
            ),
        },
        {
            title: "Amount",
            dataIndex: "amount",
            width: 120,
            align: "right",
            render: (amount) => (
                <Text fw={700} c="green">
                    ₹ {Number(amount).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                    })}
                </Text>
            ),
        },
        {
            title: "Status",
            dataIndex: "txnStatus",
            width: 110,
            align: "center",
            render: (status) => (
                <Tag
                    color={
                        status === "SUCCESS"
                            ? "green"
                            : status === "FAILED"
                                ? "red"
                                : "orange"
                    }
                >
                    {status}
                </Tag>
            ),
        },
        {
            title: "Remarks",
            dataIndex: "remarks",
            width: 220,
            // ellipsis: true,
            render: (remarks) => remarks || "-",
        },
        {
            title: "Transfer Time",
            dataIndex: "txnTime",
            width: 180,
            render: (date) =>
                dayjs(date).format("DD MMM YYYY hh:mm A"),
        },
    ];
    const { user } = Userauthcontexthooks();
    const [fetchlogsLoading, setFetchlogsLoading] = useState(true);
    const [fundlogs, sefundlogs] = useState([]);
    const [FilteredFundlogs, setFilteredFundlogs] = useState([]);
    const [searchlogs, setsearchlogs] = useState('');
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });

    const handleSearch = () => {
        let filtered = [...fundlogs];

        // Search Filter
        if (searchlogs.trim()) {
            const keyword = searchlogs.toLowerCase().trim();

            filtered = filtered.filter((item) =>
                item.fromDetails?.userName?.toLowerCase().includes(keyword) ||
                item.fromDetails?.userCode?.toLowerCase().includes(keyword) ||
                item.toDetails?.userCode?.toLowerCase().includes(keyword) ||
                item.toDetails?.userCode?.toLowerCase().includes(keyword)
            );
        }

        setFilteredFundlogs(filtered);
    };

    const handleReset = () => {
        setsearchlogs("");
        setFilteredFundlogs(fundlogs);
    };

    const fetchLogs = async (page = 1, pageSize = 10) => {
        try {
            const data = await Get_FundLogs(page, pageSize);
            if (data.success) {
                //console.log(data);
                sefundlogs(data?.Fundlogs);
                setFilteredFundlogs(data?.Fundlogs);

                setPagination({
                    current: data.pagination.current,
                    pageSize: data.pagination.pageSize,
                    total: data.pagination.total,
                });
            }
        } catch (error) {
            console.log(error);
            message.error(
                error.response?.data?.message ||
                "Something went wrong."
            );
        } finally {
            setFetchlogsLoading(false);
        }
    }

    useEffect(() => {
        const fetchLogs = async (page = 1, pageSize = 10) => {
            try {
                const data = await Get_FundLogs(page, pageSize);
                if (data.success) {
                    //console.log(data);
                    sefundlogs(data?.Fundlogs);
                    setFilteredFundlogs(data?.Fundlogs);

                    setPagination({
                        current: data.pagination.current,
                        pageSize: data.pagination.pageSize,
                        total: data.pagination.total,
                    });
                }
            } catch (error) {
                console.log(error);
                message.error(
                    error.response?.data?.message ||
                    "Something went wrong."
                );
            } finally {
                setFetchlogsLoading(false);
            }
        }

        if (user) {
            fetchLogs();
        }

    }, [user])

    return (
        <>
            <Topnavbar Headername={Headername} />
            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Fund Logs</Title>
                <Text size="xs">You can view the fund(s) log's</Text>
            </Container>
            <Container size={'lg'} mt={'lg'}>
                <Card title="Logs" style={{
                    width: "100%",
                }}>
                    <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>

                        <Col xs={24} md={6}>
                            <Search
                                placeholder="Search by Name/ Code"
                                allowClear
                                value={searchlogs}
                                onChange={(e) => setsearchlogs(e.target.value)}
                                onSearch={handleSearch}
                            />
                        </Col>

                        <Col xs={24} md={6}>
                            <Space>
                                <Button
                                    type="primary"
                                    onClick={handleSearch}
                                >
                                    Search
                                </Button>

                                <Button
                                    onClick={handleReset}
                                    variant="light"
                                >
                                    Reset
                                </Button>
                            </Space>
                        </Col>
                    </Row>

                    <div style={{ width: "100%", overflowX: "auto" }}>
                        <Table
                            columns={columns}
                            dataSource={FilteredFundlogs}
                            loading={fetchlogsLoading}
                            bordered
                            size="middle"
                            rowKey="_id"
                            pagination={pagination}
                            onChange={(page) => {
                                fetchLogs(page.current, page.pageSize);
                                setFetchlogsLoading(true)
                            }}
                        />
                    </div>

                </Card>
            </Container>
        </>
    )
}

export default Fundlogs;